import { useFeatureFlag } from '~/context/featureFlag'
import { usePlatformConfig } from '~/context/platform'
import { isHouseholdRedemptionEnabledForOpCo } from '~/utils/household'

/** Whether orders in the current market can be paid from the household Avios balance */
const useIsHouseholdRedemptionEnabled = (): boolean => {
  const { opCo } = usePlatformConfig()
  const isIberiaHouseholdEnabled = useFeatureFlag('iberia-hh-enabled')

  return isHouseholdRedemptionEnabledForOpCo(opCo, isIberiaHouseholdEnabled)
}

export default useIsHouseholdRedemptionEnabled
